import { graphql } from 'relay-runtime';

export const AUTH_QUERY = graphql`
  query authorizeUserQuery {
    userContext {
      userId
      isIntercomEnabled
      email
      role
      jobTitle
      currentCompany {
        companyId
        name
        databaseConnections {
          databaseType
        }
        config {
          hideDefinitionSqlRows
        }
        primaryDomain {
          domain
        }
        createdAt
      }
      permissions
      teams {
        id
      }
    }
  }
`;
